<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="700px"
      :title="$l('dialog_title_changeDetail') || '变更详情'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :amzPurchaseChangeCode="amzPurchaseChangeCode"
        :amzPurchaseDetailCode="amzPurchaseDetailCode"
        :changeType="changeType"
        :changeFields="changeFields"
        :disabled="disabled"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('btn_change') || '变更' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzPurchaseChangeCode: { type: String, default: '' },
    amzPurchaseDetailCode: { type: String, default: '' },
    changeType: { type: String, default: '' },
    changeFields: { type: Array, default: () => [] },
    optType: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return this.optType === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
